import React, { useState, useEffect } from 'react'
import { Box, Title, Modal, Text } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { getPaymentConfirmation, deleteProofPayment } from '../../../../services/payment'
import NoData from '../../../ui/NoData'
import LoadingData from '../../../ui/LoadingData'
import OrderProofOfPaymentTable from './LayoutHelper/OrderProofOfPaymentTable'
import FormAdjustProofPayment from './Form/FormAdjustProofPayment'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData'

const labelTable = [
  {
    label: 'Bank Name',
    width: 'auto'
  },
  {
    label: 'Bank Account Name',
    width: 'auto'
  },
  {
    label: 'Bank Account Number',
    width: 'auto'
  },
  {
    label: 'Amount Transferred',
    width: 'auto'
  },
  {
    label: 'Payment Date',
    width: 'auto'
  },
  {
    label: 'Submitted By',
    width: 'auto'
  },
  {
    label: 'Transfer To',
    width: 'auto'
  },
  {
    label: 'Image',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const OrderProofPayment = () => {
  const params = useParams()
  const orderId = params.order_id
  const [loading, setLoading] = useState(true)
  const [proofPaymentList, setProofPaymentList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetProofPayment = async () => {
    setLoading(true)
    const params = {
      'filter[order_id][is]': orderId,
    }
    try {
      const response = await getPaymentConfirmation(params)
      if (response.success) {
        const proofPaymentData = response.data

        const remapData = proofPaymentData.map((val) => {
          return val.attributes
        })

        setProofPaymentList(remapData)
      } else {
        setProofPaymentList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleGetProofPayment()
    // eslint-disable-next-line
  }, [orderId])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteData('Proof of Payment', val.id, val.customer_name, deleteProofPayment, handleGetProofPayment)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalFormProofPayment = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={20}>
        <Title size={16} fw={500}>Proof of Payment</Title>
        <Box my={30}>
          {loading ? <LoadingData /> : proofPaymentList.length > 0 ? <OrderProofOfPaymentTable label={labelTable} data={proofPaymentList} actionMethod={handleAction} /> : <NoData />}
        </Box>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalFormProofPayment} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Proof Of Payment</Text>} withCloseButton={false}>
        <FormAdjustProofPayment dataPayment={detailData} onCloseForm={onCloseModalFormProofPayment} reloadList={handleGetProofPayment} />
      </Modal>
    </Box>
  )
}

export default OrderProofPayment